import { Typography, ButtonBase, CircularProgress } from "@material-ui/core";
import ImageIcon from "@material-ui/icons/Image";
import * as S from "./styles";
import { RightArrow } from "../../../../assets/icons";
import React, { useEffect, useState } from "react";
import { useGlobal } from "../../../../contexts/globalContext";
import formatActivityPrice, { activityPriceInfo } from "../../../../utils/formatActivityPrice";

const getActivityImage = (activity) =>
	activity.photos?.gallery?.[0]?.paths?.thumbnail ||
	activity.images?.[0]?.url ||
	activity.image ||
	activity.mainImage ||
	activity.pictureUrl ||
	activity.thumbnail ||
	activity.media?.[0]?.url ||
	activity.photo ||
	null;

const ActivityImageWithFallback = ({ imageUrl, displayName }) => {
	const [loadError, setLoadError] = useState(false);

	if (!imageUrl || loadError) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					backgroundColor: "#f0f0f0",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<ImageIcon style={{ fontSize: "40px", color: "#ccc" }} />
			</div>
		);
	}

	return <img alt={displayName} src={imageUrl} className='cardImage' onError={() => setLoadError(true)} />;
};

const SearchResults = ({
	activities,
	destinations,
	submit,
	searchTerm,
	showResults,
	handleSelectDestination,
	handleSelectActivity,
	loading,
}) => {
	const { setLoading, user } = useGlobal();
	const priceInfo = activityPriceInfo(user);

	useEffect(() => {
		setLoading(loading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading]);

	if (!showResults && !loading) return null;

	if (loading) {
		return (
			<S.Box>
				<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "32px 16px", gap: 12 }}>
					<CircularProgress size={32} />
					<S.CustomTypography variant='body2'>
						Carregando as opções...
					</S.CustomTypography>
				</div>
			</S.Box>
		);
	}

	const noResults = !destinations?.length && !activities?.length;

	return (
		<S.Box>
			{noResults && (
				<S.CustomTypography className='searchTitle' variant='h6'>
					Nenhuma opção encontrada
				</S.CustomTypography>
			)}

			{destinations?.length > 0 && (
				<>
					<Typography className='searchTitle'>Destinos</Typography>
					{destinations.slice(0, 5).map((destination) => {
						const destKey = destination.destinationId || destination.id || destination.name;
						const destName = destination.name || destination.city;
						return (
							<div key={destKey}>
								<Typography
									onClick={() => handleSelectDestination({ ...destination, destinationId: destKey })}
									className='foundCities'
								>
									<RightArrow className='rightArrow' /> {destName}
									{destination.countryName || destination.country
										? ` — ${destination.countryName || destination.country}`
										: ''}
								</Typography>
							</div>
						);
					})}
				</>
			)}

			{activities?.length > 0 && (
				<>
					<Typography className='searchTitle'>Atividades</Typography>
					{activities.slice(0, 4).map((activity) => {
						const key = activity.activityId || activity.id;
						const displayName = activity.title || activity.name || `Atividade ${key}`;
						const truncated = displayName.length > 80 ? `${displayName.substring(0, 78)}...` : displayName;
						const imageUrl = getActivityImage(activity);
						const price = formatActivityPrice(activity, priceInfo);
						return (
							<div
								className='card'
								key={key}
								onClick={() => handleSelectActivity({ ...activity, activityId: key })}
							>
								<ButtonBase className='cardMedia'>
									<ActivityImageWithFallback imageUrl={imageUrl} displayName={displayName} />
								</ButtonBase>
								<div className='cardContent'>
									<Typography className='cardTitle'>{truncated}</Typography>
									<Typography className='cardCity'>
										{activity.location || activity.city || activity.destinationName}
									</Typography>
									{price && (
										<Typography className='cardPrice'>
											<span className='text'>A partir de&nbsp;</span>
											{`${price.amount}${price.suffix ? ` ${price.suffix}` : ""}`}
										</Typography>
									)}
								</div>
								<S.StyledArrowForwardIcon />
							</div>
						);
					})}
				</>
			)}

			{activities?.length > 0 && (
				<div
					className='allResults submit'
					onClick={() => submit(searchTerm)}
				>
					<Typography className='allResults'>Ver todos os resultados</Typography>
					<S.StyledArrowForwardIcon className='allResultsIcon' />
				</div>
			)}
		</S.Box>
	);
};

export default SearchResults;
